import styled from "styled-components";

const LabelText = styled.span`
  color: ${({ theme }) => theme.NumberColor};
  font-feature-settings: "clig" off, "liga" off;

  /* Aeonik/Body/Medium */
  font-family: Aeonik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 125% */

  /* You can add more specific styles as needed, such as for different sizes or variations */
  &.small {
    font-size: 14px;
    line-height: 1.2; /* Adjust line-height accordingly */
  }

  &.large {
    font-size: 18px;
    line-height: 1.3; /* Adjust line-height accordingly */
  }

  &.player-given-name {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.playerColor};
  }

  &.comparison-table-header {
    font-size: 16px;
    font-weight: 700;
    color: ${({ theme }) => theme.playerColor};
    cursor: pointer;
  }

  &.player-detail-given-name {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    color: ${({ theme }) => theme.playerColor};
  }

  &.player-family-name {
    color: ${({ theme }) => theme.playerColor};
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    @media (max-width: 1366px) {
      font-size: 22px;
    }
  }

  &.player-detail-family-name {
    color: ${({ theme }) => theme.playerColor};
    font-size: 56px;
    font-weight: 700;
    line-height: 66px;
    @media (max-width: 1200px) {
      font-size: 40px;
      line-height: 50px;
    }
    @media (max-width: 991px) {
      font-size: 30px;
      line-height: 40px;
    }
  }

  &.player-search-text {
    color: ${({ theme }) => theme.playerColor};
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
    text-transform: none;
    padding-bottom: 8px;
    @media (max-width: 991px) {
      font-size: 16px;
      line-height: 24px;
    }
  }

  &.page-title-text {
    color: ${({ theme }) => theme.playerColor};
    font-size: 56px;
    font-weight: 700;
    line-height: normal;
    @media (max-width: 1366px) {
      font-size: 30px;
    }
  }

  &.custom-list-strong-text {
    color: ${({ theme }) => theme.playerColor};
    font-size: 20px;
    line-height: 24px;
  }

  &.custom-list-text {
    font-size: 20px;
    line-height: 24px;
  }

  &.player-team-text {
    font-family: "DM Mono";
    font-size: 10px;
    line-height: 10px; /* 100% */
    text-transform: uppercase;
  }

  &.selected-player-text {
    font-size: 20px;
    font-weight: 700;
    line-height: 24px;
  }

  &.selected-zone-name {
    text-align: right;
    font-family: "DM Mono";
    font-size: 12px;
    line-height: 12px; /* 100% */
    text-transform: uppercase;
  }
  &.overall-text {
    text-align: right;
    font-family: "DM Mono";
    font-size: 14px;
    line-height: 14px; /* 100% */
    text-transform: uppercase;
  }

  &.header-text {
    color: ${({ theme }) => theme.playerColor};
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;
    @media (max-width: 991px) {
      font-size: 18px;
    }
  }

  &.secondary-cta-text {
    color: ${({ theme }) => theme.playerColor};
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 24.605px; /* 175.749% */
    // padding-right: 8px;
  }

  &.primary-cta-text {
    color: var(--Brand-black-500, #111);
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px; /* 128.571% */
  }
  &.primary-disabled-text {
    color: #009477;
    text-align: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px; /* 128.571% */
  }
  &.modal-text {
    color: var(--UI-red-500, #ff3864);
  }
  &.notification-title {
    color: ${({ theme }) => theme.notificationTitleColor};
    font-size: 20px;
    font-weight: 700;
    line-height: 18px;
  }
  &.notification-text {
    color: ${({ theme }) => theme.notificationTextColor};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
  }
     &.roadmap-text {
    color: ${({ theme }) => theme.NumberColor};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
  }
  &.notification-alter-text {
    color: ${({ theme }) => theme.notificationTitleColor};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    max-width: 364px;
  }
  &.club-league {
    font-size: 24px;
    font-weight: 700;
    line-height: 30px; /* 125% */
    @media (max-width: 991px) {
      font-size: 20px;
    }
  }

  &.tooltip-text {
    color: ${({ theme }) => theme.playerColor};
  }

  &.drawer-title {
    color: ${({ theme }) => theme.playerColor};
    font-size: 32px;
    font-weight: 700;
    line-height: 40px;
    margin-bottom: 0px;
    @media (max-width: 1366px) {
      font-size: 24px;
    }
  }
  &.profile-name {
    color: ${({ theme }) => theme.playerColor};
    font-size: 20px;
    font-weight: 500;
    line-height: 24px; /* 120% */
    @media (max-width: 1366px) {
      font-size: 16px;
    }
  }
  &.team-selection-text {
    font-family: "DM Mono";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px; /* 100% */
    text-transform: uppercase;
  }
  &.select-team-label {
    font-weight: 700;
    font-size: 20px;
    color: #00d1a8;
    text-transform: none;
  }
  &.empty-data-text {
    color: ${({ theme }) => theme.playerColor};
    font-family: Aeonik;
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 14px;
  }
  &.event-tooltip-title {
    color: var(--UI-blue-500, #00a1e4);
  }
  &.squad-chart-tooltip {
    color: ${({ theme }) => theme.playerColor};
    font-family: Aeonik;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
  &.total-new {
    color: #7c7d79 !important;
  }
  &.market-value-text {
    color: ${({ theme }) => theme.playerColor};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 14.4px; /* 128.571% */
  }
  &.player-filter-labeltext {
    color: ${({ theme }) => theme.playerColor};
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 120% */
  }
  &.clear-labeltext {
    color: ${({ theme }) => theme.playerColor};
    text-align: right;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 128.571% */
  }
  &.altered-text {
    color: ${({ theme }) => theme.alteredTextColor};
    font-family: "DM Mono";
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px; /* 100% */
    text-transform: uppercase;
  }
  &.view-player-text {
    color: ${({ theme }) => theme.playerColor};
    font-family: "DM Mono";
    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: 10px; /* 100% */
    text-transform: uppercase;
  }

  &.global-search-text {
    font-family: Aeonik;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
  }
  &.disabled-text {
    color: ${({ theme }) => theme.playerCardBorderColor};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px; /* 128.571% */
  }
  &.error-text {
    color: var(--Shades-UI-Red-red-500, #ff3764);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
  }

  &.remove-sortlist-text {
    font-size: 16px;
    font-weight: 700;
    color: #ff7800;
  }

  /*Jigar 3-Dec-2024*/
  &.remove-text {
    color: #ff7800;
    font-weight: 700;
  }
  &.player-comparision-table-chip {
    color: var(--UI-red-500, #ff3864);
    text-align: center;
    leading-trim: both;
    text-edge: cap;
    font-feature-settings: "liga" off, "clig" off;
    font-family: "DM Mono";
    font-size: 7px;
    font-style: normal;
    font-weight: 500;
    line-height: 12px; /* 171.429% */
    text-transform: uppercase;
  }
  &.comparison-score-text {
    color: var(--Brand-white-500, #fff);
    font-feature-settings: "liga" off, "clig" off;

    /* Aeonik/Body/Medium */
    font-family: Aeonik;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
  }
  &.page-notfound-text {
    color: var(--Warm-Grey-warm-grey-400, #c2c2c2);
    text-align: center;
    font-family: Aeonik;
    font-size: 56px;
    font-style: normal;
    font-weight: 700;
    line-height: 66px; /* 117.857% */
  }
  &.menu-list {
    color: var(--Brand-black-500, #111);
    font-family: Aeonik;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
    text-transform: capitalize;
  }
  &.no-data-text {
    color: var(--Warm-Grey-warm-grey-400, #c2c2c2);
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
  }
  &.three-named-player {
    font-family: "Aeonik";
    font-size: 32px;
    font-weight: 700;
    color: #111111;
    line-height: 40px;
    margin-top: 50px;
  }
  &.three-named-similar-player {
    font-family: "Aeonik";
    font-size: 32px;
    font-weight: 700;
    color: #111111;
    line-height: 40px;
    margin-top: 30px;
  }
  &.club-given-name {
    font-family: "Aeonik";
    font-weight: 700;
    color: #111111;
    line-height: 40px;
    font-size: 32px;
  }
  &.home-playerlist-boldtext{
      color: var(--Brand-black-500, #111);
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px; /* 125% */
  }
   &.home-playerlist-normaltext{
      color: var(--Brand-black-500, #111);
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
  }
  &.home-tool-text{
    color: var(--Brand-black-500, #111);
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 120% */
  }
    &.archtype-tag-text{
      color: var(--Brand-black-500, #111);
      font-size: 11.2px;
      font-weight: 700;
      line-height: 14.4px; /* 128.571% */
    }
  &.image-header-font{
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 250;
    font-size: 18px;
    line-height: 20px;
    /* or 111% */
    letter-spacing: 0.2px;
    color: #FFFFFF;
  }
    &.image-header-font2{
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: 22px;
    line-height: 20px;
    /* or 111% */
    letter-spacing: 0.2px;
    color: #FFFFFF;
  }
    &.player-club-text{
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */
    letter-spacing: 0.2px;
    color: #FFFFFF;
    }
    &.player-club-text2{
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: 18px;
    /* identical to box height, or 150% */
    letter-spacing: 0.2px;
    color: #FFFFFF;
    }
    &.player-club-text3{
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 250;
    font-size: 8px;
    line-height: 18px;
    /* identical to box height, or 150% */
    letter-spacing: 0.2px;
    color: #FFFFFF;
    }
    &.upper-lower-font{
    font-family: 'Inter';
font-style: normal;
font-weight: 400;
font-size: 12px;
line-height: 22px;
/* identical to box height, or 183% */

color: #4AF075;}

&.rating-header{
font-family: 'Aeonik';
font-style: normal;
font-weight: 250;
font-size: 18px;
line-height: 22px;
letter-spacing: -0.3px;

color: #FFFFFF;

}
`;

export default LabelText;
